<template>
<section class="container list-page" style="max-width:1000px">
    <div >
        <!-- <a>Link</a> -->
        <Breadcrumb 
            :levelTwoText = "'Countries'"
        />
        <Heading 
            :heading="'Explore Countries'"
        /> 
        <RadioFilter 
            v-on:selection-change="updateSelectedContinent"
            :options = "$continentsArray"
            :type = "'Continent'"
        />
        <div class="spacer" style="height:30px"></div>
            
        <div class="small-label">By Name</div>    
        <div style="max-width:350px; margin-left:auto; margin-right:auto">
            <b-field label="">
                <b-input v-model="filterInput" placeholder='Country name'></b-input>
            </b-field>
        </div>
        <div class="spacer" style="height:30px"></div>
        <!-- <div class="spacer" style="height:60px"></div> -->
        <div v-if="links.length > 0">
           
            <!-- COUNTRIES -->
            <!-- <div v-if="type=='countries'"> -->

                <!-- <ContinentFilter 
                    v-on:continent-change="updateSelectedContinent"
                /> -->
                

                <div class="block is-size-7" style="text-align:left; margin-bottom:5px">
                    <!-- <span class="title is-size-6">Order By: </span> -->
                    <b-radio v-model="orderby"
                        native-value="posts"
                        type="is-info is-light">
                        <span>Post Count</span>
                    </b-radio>

                    <b-radio v-model="orderby"
                        native-value="name"
                        type="is-info is-light is-outlined is-small">
                        <span>Alphabetical</span>
                    </b-radio>
                </div>

                <ul v-if="$countrymap && links.length > 0">
                    <li  class="list-link" v-for="linkObj in sortedRows" v-bind:key="linkObj.id">
                        <!-- <pre>{{linkObj}}</pre> -->
                        <CountryRow 
                            :countryObj = linkObj
                            :selectedContinent = selectedContinent
                            v-if = "(  filterInput != '' && $countrymap[linkObj.id].toLowerCase().includes(filterInput.toLowerCase()) || filterInput == ''  )"
                        />

                    </li>
                </ul>
            <!-- </div> -->

        </div>
        <!-- <pre>{{type}}</pre> -->
        
        <div class="section card" ref="results" v-if="isLoading">
            <b-icon class="fas fa-spinner fa-spin"></b-icon>
            Loading...
        </div>
        <div class="spacer" style="height:60px"></div>  
        
    </div>
    </section>
</template>

<script>
import CountryRow from '@/components/CountryRow';
import Heading from '@/components/Heading';
import ContinentFilter from '@/components/ContinentFilter';
import RadioFilter from '@/components/RadioFilter';
import Breadcrumb from '@/components/Breadcrumb';


export default {
  name: 'LinksList',
//   props: ['type'],
  components: { CountryRow, Heading, ContinentFilter, RadioFilter, Breadcrumb },
  data () {
    return {
        links: [],
        // routesData: [],
        orderby: 'posts',
        filterInput: '',
        isLoading: false,
        selectedContinent: "All",
        singularMap: { countries: "country", routes: "route", sites: "site", ridertags: "rider tag", continents: "continent" },
        displayTextMap: { Transamerica: "TransAmerica" , 'Pan-american Highway': "Pan-American Highway"} // copied from findTrip
        // type: this.type
    }
  },
  computed: {
    sortedRows() {
        if (this.orderby == 'posts') {
            return [...this.links].sort((a, b) => (a.post_count > b.post_count) ? -1 : 1);
        } else {
            return [...this.links].sort((a, b) => (this.$countrymap[a.id] > this.$countrymap[b.id]) ? 1 : -1);
        }
    }
  },
//   metaInfo() {
    
//         return {
//             title: '**** Browse | Bike Sleep Bike',
//             description: "Find bike travel blogs"
            
//         }
//     },
  methods: {
      updateSelectedContinent(newContinent) {
          this.selectedContinent = newContinent;
      },
      getDisplayText(val) {
          if (this.displayTextMap[val]) {
              return this.displayTextMap[val];
          } else {
              return val;
          }

      },
    //   displayMapping(type) {
    //       if (type == 'ridertags') {
    //           return "rider tags";
    //       } else {
    //           return type;
    //       }
    //   },
      comparePostCount(a, b) {
        //   console.log(a);
          if (a.post_count > b.post_count) {return -1; }
          if (a.post_count < b.post_count) {return 1; }
          return 0;
      },
      titleCase(str) {
        //   console.log(str);
            str = str.toLowerCase();
            str = str.split(' ');
            for (var i = 0; i < str.length; i++) {
                str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
          
            }
            return str.join(' ');
        },
        getLinks() {
            // this.type = this.$route.params.type;
            this.links = [];
            var result = [];
            var that = this;
            // this.$db.collection(that.type).orderBy("post_count", "desc").get()
            // .then(function(querySnapshot) {
            //     querySnapshot.forEach(function(doc) {
            //         // doc.data() is never undefined for query doc snapshots
            //         // console.log(doc.id, " => ", doc.data());
            //         var dataAndId = doc.data();
            //         dataAndId['id'] = doc.id;
            //         result.push(dataAndId);
                
            //     });
            //     that.links = result;
            // })
            // .catch(function(error) {
            //     console.log("Error getting links by type: ", error);
            // });
                this.isLoading = true;
                this.$db.collection("page_counts").doc('countries').get()
                .then(function(doc) {
                    if (doc.exists) {
                        for (const linkProp in doc.data()) {
                        
                            const dataObj = doc.data()[linkProp];
                            dataObj.id = linkProp;
                            result.push(dataObj);
                        }
                        result = result.sort(that.comparePostCount);
                        that.links = result;
                        that.isLoading = false;
                            // that.links = doc.data();
                    } else {
                        console.log("ERROR: Can't fetch countries");
                        that.isLoading = false;
                    }
                })
                .catch(function(error) {
                    console.log("Error getting links by type: ", error);
                    that.isLoading = false;
                });

            },
            //  getRoutes() {
            //     console.log("Getting route data");
            //     this.routesData = [];
            //     var result = [];
            //     var that = this;
            //     var pageCountData = {};
            //     var routesMetadata = [];
            //     // first get routes page counts
            //     this.$db.collection("page_counts").doc(that.type).get()
            //      .then(function(doc) {
            //         if (doc.exists) {
            //             var temp = {};
            //             temp[doc.id] = doc.data();
            //             pageCountData = temp.routes;
            //             // console.log(pageCountData);
            //             // then get routes metadata
            //             that.$db.collection("routes").get().then((querySnapshot) => {
            //                 querySnapshot.forEach((doc) => {
            //                     // doc.data() is never undefined for query doc snapshots
            //                     var temp2 = {};
            //                     // temp2[doc.id] = doc.data();
            //                     routesMetadata.push(doc.data());
            //                 });
            //                 // console.log(routesMetadata);

            //                 // then merge the two
            //                 for (var i = 0; i < routesMetadata.length; i++) {
            //                     var displayName = routesMetadata[i].display_name;
            //                     if (displayName in pageCountData) {
            //                         // console.log(routesMetadata[i]);
            //                         // console.log(pageCountData[displayName].post_count);
            //                         var newobj = routesMetadata[i];
            //                         newobj.post_count = pageCountData[displayName].post_count;
            //                         that.routesData.push(newobj);
            //                     }
            //                 }
            //                 // console.log(that.routesData);

            //             });

            //         } else {
            //             console.log("ERROR: Can't fetch links by type", that.type);
            //         }

            //     })
            //     .catch(function(error) {
            //         console.log("Error getting links by type: ", error);
            //     });
                
      
            //  }
 

  
  },
   metaInfo() {
        var title =  'Country List: Explore bike touring blogs from more than 120 countries';
        var description = "Discover the best places to go bicycle touring and bikepacking, and read trip reports from cyclists who've been there.";
        return {
            title: title,
            titleTemplate: this.$titleTemplate, 
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },
  watch: {
    // "$route.params.type": function(oldType, newType) {
    //     // console.log("type param changed to ", newType);
    //     // this.type = newType;
    // },
    // type: function(oldType, newType) {
    //     // console.log("Type variable changed to ", this.type);
    //     // this.links = ["link 1", "link 2"];
    //     // this.getLinks();

    // }
  },
  beforeRouteEnter(to, from, next) {
      next(component => {
        //   if (component.type == 'routes') {
            //   component.getRoutes();
        //   } else {
              component.getLinks();
        //   }
          
      })
  },
  beforeRouteChange(to, from, next) {
    //   if (this.type == 'routes') {
        //   this.getRoutes();
    //   } else {
        this.getLinks();
    //   }
      
  },
  mounted() {
    // this.type = this.$route.params.type;
    this.getLinks(); //ADDED FOR REWRITES
    // if (this.type == "routes") {
    //     this.getRoutes();
    // }
    this.selectedContinent = "All";
    
  },
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .list-link {
        margin-bottom:10px;
        font-size: 1.1em;
    }
    /* .ridertag-row {
        padding: 30px;
        background-color: white;
    } */
    .list-link .card a {
        color:black;
    }
    .ridertag-row {
        max-width:500px;
        margin-left:auto;
        margin-right:auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Countries.vue